import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: 'admin/partners/list',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: 'admin/partners/destroy',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: 'admin/partners/createOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: 'admin/partners/createOrUpdate',
      method: 'post',
      data
    })
  },
  Detail(id) {
    return request({
      url: 'admin/partners/detail',
      method: 'post',
      params: { id }
    })
  }
}

export default api
